import { ArrowLeftStartOnRectangleIcon } from '@heroicons/react/24/outline';
import { Link, useParams } from 'react-router';
import { useParentPathwayId, useParentCaseId, useParentNodeId } from '@/stores/pathwayStore';

const ExitInternalsViewButton = () => {
  const { projectId } = useParams();
  const parentPathwayId = useParentPathwayId();
  const parentCaseId = useParentCaseId();
  const parentNodeId = useParentNodeId();

  if (!parentPathwayId || !parentCaseId || !parentNodeId) {
    return null;
  }

  return (
    <Link
      to={`/projects/${projectId}/build/pathways/${parentPathwayId}/${parentCaseId}/nodes/${parentNodeId}`}
      className="inline-flex items-center gap-2 bg-stone-100 hover:bg-stone-200 border border-blue-300 hover:border-blue-400 text-blue-700 font-medium text-sm px-3 py-1.5 rounded-md shadow-sm"
    >
      <ArrowLeftStartOnRectangleIcon className="w-4 h-4 shrink-0" />
      Exit Internals View
    </Link>
  );
};

export default ExitInternalsViewButton;
